import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Text } from '../components/Text.js';
import { Loader } from '../components/Loader.js';
import { FlexRow } from '../components/FlexRow.js';
import { FormCard } from '../components/FormCard.js';
import { CardTitle } from '../components/CardTitle.js';
import { FormInput } from '../components/FormInput.js';
import { FormError } from '../components/FormError.js';
import { callFetch } from '../helpers/fetch.js';
import { SSO_API_URL } from '../sso-secrets.js';
import { AntButton, SubmitButton } from '../components/SubmitButton.js';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  // form data fields
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);

  const params = new URLSearchParams(location.search);
  const redirectURL = params.get('redirect_url');

  const onEmailChange = (event) => setEmail(event.target.value);
  const onPasswordChange = (event) => setPassword(event.target.value);

  const onSubmit = async () => {
    try {
      setSubmitting(true);

      const response = await callFetch(
        `${SSO_API_URL}/api/sso-client/sign-in`,
        {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password, redirectURL }),
        },
      );

      setSubmitting(false);

      if (!response?.ok) {
        setError(response?.error);
        return;
      }

      if (response?.ok) {
        setError(null);
        window.location.href = `${SSO_API_URL}/complete-sign-in?redirect_url=${redirectURL}`;
      }
    } catch (error) {
      console.log(`Sign In page: ${error}`);
    }
  };

  const onSignup = () => {
    navigate(`/sign-up?redirect_url=${redirectURL}`);
  };

  // TODO: duplicated code
  // Note: If user already signed in, we just need
  //       to set tokens in cookies and redirect back
  useEffect(() => {
    const isUserAlreadySignIn = async () => {
      const response = await callFetch(
        `${SSO_API_URL}/api/sso-client/is-user-signed-in`,
      );

      // if already sign in then need to set tokens into cookies
      if (response?.ok) {
        window.location.href = `${SSO_API_URL}/complete-sign-in?redirect_url=${encodeURIComponent(
          redirectURL,
        )}`;
        return;
      }

      // if user not signed in then need to display sign in form
      setLoading(false);
    };

    isUserAlreadySignIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <FormCard>
      <CardTitle>Sign In Form</CardTitle>
      {error && <FormError>{error}</FormError>}
      <FormInput label="Email" onChange={onEmailChange} />
      <FormInput label="Password" onChange={onPasswordChange} type="password" />
      <SubmitButton onClick={onSubmit} loading={submitting}>
        Submit
      </SubmitButton>
      <FlexRow margin="10px 0 0 0" justify="center" align="center">
        <Text margin="0 5px 0 0">Not have an account?</Text>
        <AntButton style={{ padding: '0' }} type="link" onClick={onSignup}>
          Sign Up now
        </AntButton>
      </FlexRow>
    </FormCard>
  );
}
